import React from 'react';
import { BarChart2, DollarSignIcon, CoinsIcon, Timer} from 'lucide-react';
import DateRangeFilter from './DateRangeFilter';

const SummaryMetrics = ({
  summaryMetrics,
  dateRange, setDateRange,
  showCustomDatePicker, setShowCustomDatePicker,
  customStartDate, setCustomStartDate,
  customEndDate, setCustomEndDate,
  isLoading, fetchSummaryData
}) => {
  // Format currency
  const formatCurrency = (value) => {
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
      minimumFractionDigits: 4,
      maximumFractionDigits: 6
    }).format(value);
  };

  // Format number with commas
  const formatNumber = (value) => {
    return new Intl.NumberFormat('en-US').format(value);
  };

  // Format time (ms to seconds)
  const formatTime = (value) => {
    if (value === undefined || value === null) {
      return "0.00s";
    }
    return `${value.toFixed(2)}s`;
  };

  // Define summary metrics for display
  const metricCards = [
    {
      title: "Total Prompts",
      value: formatNumber(summaryMetrics.totalPrompts),
      icon: <BarChart2 size={18} className="text-primary" />
    },
    {
      title: "Total Cost",
      value: formatCurrency(summaryMetrics.totalCost),
      icon: <DollarSignIcon size={18} className="text-primary" />
    },
    {
      title: "Avg. Latency",
      value: formatTime(summaryMetrics.avgLatency),
      icon: <Timer size={18} className="text-primary" />
    },
    {
      title: "Avg. Tokens",
      value: formatNumber(Math.round(summaryMetrics.avgTokens)),
      icon: <CoinsIcon size={18} className="text-primary" />
    }
  ];

  return (
    <div className="bg-gray-50 py-4 mb-5">
      <div className="flex items-center justify-between mb-2">
        <h2 className="text-[14px] font-semibold text-gray-600 uppercase tracking-[0.7px]">Summary Metrics</h2>
        <DateRangeFilter
          dateRange={dateRange}
          setDateRange={setDateRange}
          showCustomDatePicker={showCustomDatePicker}
          setShowCustomDatePicker={setShowCustomDatePicker}
          customStartDate={customStartDate}
          setCustomStartDate={setCustomStartDate}
          customEndDate={customEndDate}
          setCustomEndDate={setCustomEndDate}
          isLoading={isLoading}
          fetchSummaryData={fetchSummaryData}
        />
      </div>
      <div className="grid grid-cols-2 sm:grid-cols-4 gap-3">
        {metricCards.map((metric, index) => (
          <div key={index} className="bg-white border border-gray-200 p-3 sm:p-4 rounded-lg transition-all duration-300">
            <div className="flex justify-between items-center mb-2">
              <h3 className="text-primary font-medium text-sm sm:text-base">{metric.title}</h3>
              <div className="">
                {metric.icon}
              </div>
            </div>
            <div className="text-lg sm:text-xl font-bold">{metric.value}</div>
            <div className="text-xs text-gray-500 mt-1">Last updated: {new Date().toLocaleTimeString()}</div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default SummaryMetrics;